// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { MaleHolsteinAnimalInList, MaleHolsteinAnimalInListSchema } from 'api/gen/MaleHolsteinAnimalInList';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(MaleHolsteinAnimalInListSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelMaleHolsteinAnimalInListSchema = excess(requiredPart);

export interface PagedModelMaleHolsteinAnimalInList extends t.TypeOf<typeof PagedModelMaleHolsteinAnimalInListSchema> {}
